// eslint-disable-next-line import/prefer-default-export, no-shadow
export enum VehicleActionTypes {
    GET_CUSTOMER = 'GET_CUSTOMER',
    GET_VEHICLE = 'GET_VEHICLE',
    POST_VEHICLE_LEAD = 'POST_VEHICLE_LEAD',
    POST_BIKE_LEAD = 'POST_BIKE_LEAD',
  }
  